export function toISOStringDate(date) {
  if (!(typeof date.toISOString == 'function')) {
    throw new Error('Not a valid date object')
  }
  return date.toISOString().split('T')[0]
}
